<template>
  <div>
    <v-row class="py-4">
      <v-col cols="6" v-for="(item, i) in btnList" :key="i">
        <v-btn
          width="100%"
          class="rounded-0 elevation-0 py-5"
          :class="value == i ? 'tabActiveBtn' : 'tabBtn'"
          @click="changeTab(i)"
        >
          <span>{{ item.btnText }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import helper from "@/helper/index";
export default {
  name: "GridTabs",
  props: {
    value: {
      type: Number,
    },
    user_id: {
      type: Number,
    },
    is_feature: {
      type: Boolean,
    },
  },
  data() {
    return {
      btnWithFeatureAndSameUser: [
        {
          btnText: "Featured",
          value: "featured",
          isActive: false,
        },
        {
          btnText: "Virtual Trades",
          value: "posted",
          isActive: false,
        },
        {
          btnText: "Real Trades",
          value: "real",
          isActive: false,
        },
      ],
      btnWithFeature: [
        {
          btnText: "Featured",
          value: "featured",
          isActive: false,
        },
        {
          btnText: "Virtual Trades",
          value: "posted",
          isActive: false,
        },
        {
          btnText: "Real Trades",
          value: "real",
          isActive: false,
        },
        {
          btnText: "Watchlist",
          value: "followed",
          isActive: false,
        },
      ],
      btnWithoutFeatureAndSameUser: [
        {
          btnText: "Virtual Trades",
          value: "posted",
          isActive: false,
        },
        {
          btnText: "Real Trades",
          value: "real",
          isActive: false,
        },
      ],
      btnWithoutFeature: [
        {
          btnText: "Virtual Trades",
          value: "paper",
          isActive: false,
        },
        {
          btnText: "Real Trades",
          value: "real",
          isActive: false,
        },
        {
          btnText: "Watchlist",
          value: "followed",
          isActive: false,
        },
      ],
    };
  },
  computed: {
    btnList() {
      if (this.is_feature && this.isSameUser) {
        return this.btnWithFeatureAndSameUser;
      } else if (!this.is_feature && this.isSameUser) {
        return this.btnWithoutFeatureAndSameUser;
      } else if (this.is_feature) {
        return this.btnWithFeature;
      } else {
        return this.btnWithoutFeature;
      }
    },
    isSameUser() {
      return helper.isSameUser(this.user_id);
    },
  },
  watch: {},
  methods: {
    changeTab(i) {
      this.$emit("input", i);
    },
  },
  mounted() {},
  created() {},
};
</script>
<style scoped>
.tabBtn.v-btn {
  background: #ffffff;
  color: rgba(51, 51, 51, 0.74);
}
.tabActiveBtn {
  background: #d5e8ff !important;
  color: #2d8cff !important;
}
</style>
